import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSocketIO from 'vue-socket.io'
import VueMeta from 'vue-meta'
import Vue2Filters from 'vue2-filters'
// CSS + BS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import '@/assets/style.css'
import moment from 'moment'
import 'moment/locale/et'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueApexCharts from 'vue-apexcharts'
import InputTag from 'vue-input-tag'
import VCA from '@vue/composition-api'
import JsonEditorVue from 'json-editor-vue'
import VueLuxon from 'vue-luxon'
Vue.config.productionTip = false

const hostname = store.getters.socketUrl

Vue.use(new VueSocketIO({ debug: false, connection: hostname }))

Vue.use(VueMeta)
Vue.use(Vue2Filters)
Vue.use(VueSweetalert2)
Vue.use(VueApexCharts)
Vue.use(VCA)
Vue.use(JsonEditorVue, {
  // global props & attrs (one-way data flow)
})
Vue.use(VueLuxon, {
  input: {
    zone: 'utc',
    format: 'millis'
  },
  output: {
    format: 'full',
    locale: 'et'
  }
})
Vue.component('apexchart', VueApexCharts)
Vue.component('input-tag', InputTag)
Vue.prototype.moment = moment

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
